import { render, staticRenderFns } from "./RestoreOrderDropdownItem.vue?vue&type=template&id=9941bf7a"
import script from "./RestoreOrderDropdownItem.vue?vue&type=script&lang=js"
export * from "./RestoreOrderDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports